/* eslint-disable import/no-unresolved */
import axios from 'axios';

const cep = axios.create({
  baseURL: 'https://apps.widenet.com.br/busca-cep/api',
});

export default cep;
